  <template>
  <div class="animated fadeIn pt2 pb4">
    <div class="max-width-1 mx-auto mt4">
      <div class="clearfix">
        <div class="col-12">
          <div class="flex justify-start items-center">
            <img src="/static/svg/h.svg" class="inline-block" alt="" height="36" />
            <p class="h5 darkblue semi-bold gibson line-height-1 pl2 mb0">Håndværker.dk</p>
          </div>
          <div>
            <p class="h3 mt3 mb1 gibson line-height-golden semi-bold darkblue">Log på din konto</p>
          </div>
        </div>
        <div class="col-12 relative">
          <div id=loginform class="lightgrey-background" style="padding:0.3rem;">
            <form @submit="onSubmit">
              <div class="border white-background mediumgrey-border py2 px2">
                <div>
                  <label>Email</label>
                  <input id="email" v-model="form.username" type="email" required class="h6 regular not-rounded border mediumgrey-border p2 darkblue col-12 line-height-1 light-highlights" autocomplete="username">
                </div>
                <div class="mb2">
                  <label>Kodeord</label>
                  <input id="password" v-model="form.password" type="password" required class="h6 regular not-rounded border mediumgrey-border p2 darkblue col-12 line-height-1 light-highlights" autocomplete="current-password">
                </div>
                <div>
                  <input type="checkbox" id="remember" name="remember" checked v-if="form.rememberMe">
                  <input type="checkbox" id="remember" name="remember" v-else>
                  <label>Husk mig</label>
                </div>
                <div class="red muted-background p2 my3" v-if="form.errorMessage">
                  <p class="h6 gibson line-height-golden">{{ form.errorMessage }}</p>
                </div>
              </div>
              <div class="my2 lightgrey-background flex justify-between center items-center px2">
                <a href="#/glemte-password" class="h6 gibson primarycolor right-align">Har du brug for hjælp?</a>
                <button type="submit" id="formLogin" class="h5 action-button p2 col-6 gibson border-none not-rounded">
                  <span>Log ind</span>
                </button>
              </div>
            </form>
            <div v-if="show" class="absolute overlay top-0 lef-0 right-0 bottom-0 col-12 height-full white-backgroud" style="background: white;opacity: 70%;">
              <div class="loader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProjectLogin',
  components: {
  },
  data: function () {
    return {
      haaId: '',
      salesPerson: '',
      form: {
        username: '',
        password: '',
        rememberMe: '',
        errorMessage: ''
      },
      user: {
        name: '',
        token: '',
        role: ''
      },
      defaultpackage: [],
      show: false,
      label: 'asas',
      overlay: 1,
      eligible: ''
    }
  },
  created () {
    localStorage.removeItem('id_token_portal')
    localStorage.removeItem('id_token_portalbitrix')
    localStorage.removeItem('haaid')
    localStorage.removeItem('inbox')
    localStorage.removeItem('email')
    localStorage.removeItem('imentor')
    localStorage.removeItem('basic')
    localStorage.removeItem('onlycredit')
    localStorage.setItem('isEmailLoggedIn', false)
    localStorage.removeItem('emailAccountId')
    localStorage.removeItem('ClimatePartner')
    localStorage.removeItem('FBPostRecommendation')
    localStorage.removeItem('PartnerAccountingInteg')
    localStorage.removeItem('ExtraReservation')
    localStorage.removeItem('ExternalProWebsite')
    localStorage.removeItem('OfferCreator')
    localStorage.removeItem('PartnerloginMesterMesterReserve')
    localStorage.removeItem('PartnerLoginUdbudJobs')
    localStorage.removeItem('PartnerLoginMarketplaceReserve')
    localStorage.removeItem('PartnerloginMesterMesterPost')
    localStorage.removeItem('PartnerLoginMarketplaceViewer')
    localStorage.removeItem('PersonalPartnerLogin')
    localStorage.removeItem('AccessVideoProProfile')
    localStorage.removeItem('AccessDescriptionText')
    localStorage.removeItem('AccessDescriptionTextlimit')
    localStorage.removeItem('PartnerloginMesterMesterReserve-nummode')
    localStorage.removeItem('PartnerloginMesterMesterReserve-size')
    localStorage.removeItem('PartnerLoginMarketplaceReserve-nummode')
    localStorage.removeItem('PartnerLoginMarketplaceReserve-size')
    localStorage.removeItem('PartnerPackageHandle')
    localStorage.removeItem('showbadgewebshop')
    localStorage.removeItem('showAddendum')
    if (this.$route.query.email !== undefined) {
      this.form.username = this.$route.query.email
      this.form.password = this.$route.query.accountnumber
      setTimeout(function () {
        $('#formLogin').click()
      }, 500)
    }
    if (this.$route.query.demoreserve !== undefined) {
      localStorage.setItem('demoreserve', this.$route.query.demoreserve)
    } else {
      localStorage.removeItem('demoreserve')
    }
    localStorage.removeItem('fullName')
    localStorage.removeItem('rule')
    var cookieStorage = {
      getItem: (key) => {
        var cookies = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((acc, [key, value]) => ({...acc, [key.trim()]: value}), {})
        return cookies[key]
      },
      setItem: (key, value, expires) => {
        document.cookie = `${key}=${value}; ${'expires'}=${expires}`
      }
    }
    if (this.$route.query.email === undefined) {
      if (cookieStorage.getItem('email') !== '') {
        this.form.username = cookieStorage.getItem('email')
      }
      if (cookieStorage.getItem('password') !== '') {
        this.form.password = cookieStorage.getItem('password')
      }
    }
    if (cookieStorage.getItem('remember')) {
      this.form.rememberMe = true
    }
    sessionStorage.removeItem('email')
    sessionStorage.removeItem('password')
    this.getInitialPackageValue()
  },
  mounted () {
    if (window.location.hostname !== 'oldpartner.haandvaerker.dk' && (window.location.href === 'https://www.kundematch.dk/newpartner/#/login' || window.location.href === 'http://www.kundematch.dk/newpartner/#/login' || window.location.href === 'https://kundematch.dk/newpartner/#/login' || window.location.href === 'http://kundematch.dk/newpartner/#/login')) {
      window.location.href = 'https://partner.haandvaerker.dk/#/login'
    }
  },
  methods: {
    rememberMe () {
      var cookieStorage = {
        getItem: (key) => {
          var cookies = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((acc, [key, value]) => ({...acc, [key.trim()]: value}), {})
          return cookies[key]
        },
        setItem: (key, value, expires) => {
          document.cookie = `${key}=${value}; ${'expires'}=${expires}`
        }
      }

      var checkBox = document.getElementById('remember')
      if (checkBox.checked === true) {
        var date = new Date()
        var nextYear = date.getFullYear() + 1
        var expiryDate = date.toGMTString().toString().replace(date.getFullYear(), nextYear)
        cookieStorage.setItem('email', this.form.username, expiryDate)
        cookieStorage.setItem('password', this.form.password, expiryDate)
        cookieStorage.setItem('remember', true, expiryDate)
      } else {
        cookieStorage.setItem('email', this.form.username, 'Thu, 01 Jan 1970 00:00:00 GMT')
        cookieStorage.setItem('password', this.form.password, 'Thu, 01 Jan 1970 00:00:00 GMT')
        cookieStorage.setItem('remember', true, 'Thu, 01 Jan 1970 00:00:00 GMT')
      }
    },
    decode (pid) {
      if (window.location.hostname !== 'oldpartner.haandvaerker.dk') {
        this.$http.get(this.$bitrixapi + 'helper/encode/' + pid, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              const query = Object.assign({}, this.$route.query)
              var allquery = ''
              Object.keys(query).forEach(querys => {
                console.log('querys', querys)
                allquery += '&' + querys + '=' + query[querys]
              })
              window.location.href = 'https://partner.haandvaerker.dk/#/login?code=' + res.data + allquery
            }
          },
          (response) => {
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        )
      }
    },
    onSubmit (evt) {
      if (window.location.hostname === 'oldpartner.haandvaerker.dk') {
        this.onSubmit_old(evt)
      } else {
        evt.preventDefault()
        this.show = true
        document.getElementById('loginform').classList.add('hide')
        // alert(JSON.stringify(this.form))
        var bitrixapi = ''
        if (this.$bitrixapi === 'https://bitrixapidev.haandvaerker.dk/v1/') {
          bitrixapi = 'bitrixapidev'
        } else if (this.$bitrixapi === 'https://bitrixapimaster.haandvaerker.dk/v1/') {
          bitrixapi = 'bitrixapimaster'
        } else {
          bitrixapi = 'bitrixapi'
        }
        var data = { operation: 'auth', userName: this.form.username, password: this.form.password, bitrixapi: bitrixapi }
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              if (res.success) {
                this.show = true
                localStorage.setItem('id_token_portalbitrix', res.bitrix.token)
                localStorage.setItem('id_token_portal', res.key_portal)
                this.haaId = res.haaid
                this.salesPerson = res.key_portal
                localStorage.setItem('haaid', res.haaid)
                this.rememberMe()
                this.decode(res.haaid)
              } else {
                this.show = false
                this.form.errorMessage = 'Det er en fejl med dit brugernavn eller din adgangskode, prøv igen'
                document.getElementById('loginform').classList.remove('hide')
              }
            },
            response => {
              alert('error')
            }
          )
      }
    },
    onSubmit_old (evt) {
      evt.preventDefault()
      this.show = true
      // alert(JSON.stringify(this.form))
      var bitrixapi = ''
      if (this.$bitrixapi === 'https://bitrixapidev.haandvaerker.dk/v1/') {
        bitrixapi = 'bitrixapidev'
      } else if (this.$bitrixapi === 'https://bitrixapimaster.haandvaerker.dk/v1/') {
        bitrixapi = 'bitrixapimaster'
      } else {
        bitrixapi = 'bitrixapi'
      }
      var data = { operation: 'auth', userName: this.form.username, password: this.form.password, bitrixapi: bitrixapi }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.show = true
              localStorage.setItem('id_token_portalbitrix', res.bitrix.token)
              localStorage.setItem('id_token_portal', res.key_portal)
              this.haaId = res.haaid
              this.salesPerson = res.key_portal
              localStorage.setItem('haaid', res.haaid)
              localStorage.setItem('basic', res.basic)
              localStorage.setItem('CompanyName', res.companyName)
              localStorage.setItem('inhouse', res.inhouse)
              localStorage.setItem('email', this.form.username)
              if (res.name === '') {
                localStorage.setItem('name', res.companyName)
              } else {
                localStorage.setItem('name', res.name)
              }
              this.rememberMe()
              localStorage.setItem('haa', res.haa)
              localStorage.setItem('onlycredit', res.onlycredit)
              localStorage.setItem('imentor', res.imentor)
              localStorage.setItem('inbox', res.inbox)
              if (res.firstlogin === 0 && res.imentor !== 0) {
                // this.$router.push('/partnerfri-setup')
                // return
              }
              localStorage.setItem('isadmin', res.isadmin)
              localStorage.setItem('isshop', res.isshop)
              localStorage.setItem('climate', res.climate)
              localStorage.setItem('showbadgewebshop', 'no')
              localStorage.setItem('permission', JSON.stringify(res.permission))
              this.checkBadges(res.haaid, res.bitrix.token, res)
              this.onlycredit = res.onlycredit
            } else {
              this.show = false
              this.form.errorMessage = 'Det er en fejl med dit brugernavn eller din adgangskode, prøv igen'
            }
          },
          response => {
            alert('error')
          }
        )
    },
    forgotPassword (evt) {
      this.$router.push('/glemte-password')
    },
    checkBadges (id, token, res) {
      /* eslint-disable no-unused-vars */
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'supplier/GetSupplierProfileById/' + id, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          var prisen = res.data.c_prisen_result
          localStorage.setItem('industryname', res.data.c_primary_industry.BUSINESS)
          if (res.data.b_crm_company.UF_CRM_COMPANY_AREA_TEXT) {
            localStorage.setItem('prisenRegion', res.data.b_crm_company.UF_CRM_COMPANY_AREA_TEXT.replace('Region', ''))
          } else {
            localStorage.setItem('prisenRegion', 'Syddanmark')
          }
          if (prisen && prisen.length > 0) {
            localStorage.setItem('showbadgewebshop', 'yes')
          } else {
            localStorage.setItem('showbadgewebshop', 'no')
          }
          localStorage.setItem('partnerPrimaryIndustryv2', res.data.c_primary_industry['BRANCH_ID'])
          localStorage.setItem('partnerPrimaryIndustryText', res.data.c_primary_industry['BUSINESS'])
          localStorage.setItem('address', res.data.b_crm_company.UF_CRM_COMPANY_ADDRESS)
          localStorage.setItem('city', res.data.b_crm_company.UF_CRM_COMPANY_CITY)
          // console.log(localStorage.getItem('showbadgewebshop'))
          var partnerpackage = res.data.supplier_package
          this.getpackage(id, token, res, partnerpackage)
        },
        (err) => {
          this.getpackage(id, token, res)
          console.log('Error in checkBadges()', err)
        }
      )
    },
    // setautologin () {
    //   this.show = true
    //   localStorage.setItem('id_token_portalbitrix', res.bitrix.token)
    //   localStorage.setItem('id_token_portal', res.key_portal)
    //   localStorage.setItem('onlycredit', null)
    //   localStorage.setItem('haaid', res.haaid)
    //   localStorage.setItem('haa', true)
    //   localStorage.setItem('CompanyName', res.companyName)
    //   localStorage.setItem('climate', true)
    //   localStorage.setItem('email', this.form.username)
    //   this.gotoroute([])
    // },
    gotoroute (res) {
      if (this.$route.query.page === 'credit') {
        this.$router.push('/rediger-kreditkort-oplysninger')
      } else if (this.$route.query.page === 'creditfast') {
        this.$router.push('/rediger-kreditkort-oplysninger?credit=creditcall')
      } else if (this.$route.query.page === 'projekt-job') {
        this.$router.push('/opgaveinvitationer?proid=' + this.$route.query.proId)
      } else if (this.$route.query.page === 'editDescription') {
        this.$router.push('/confirm-description?token=' + this.$route.query.token)
      } else if (this.$route.query.page === 'mobilepay') {
        this.$router.push('/rediger-kreditkort-oplysninger?credit=mobilepaycall')
      } else if (this.$route.query.page === 'invitedirectcontract') {
        this.$router.push('/opgaveinvitationer?proid=' + this.$route.query.proId)
      } else if (this.$route.query.page === 'directcontract') {
        this.$router.push('/customer-projects/contract-main?contractId=' + this.$route.query.contractId)
      } else if (this.$route.query.page === 'directextrawork') {
        this.$router.push('/customer-projects/addon-liste?contractId=' + this.$route.query.contractId + '&projectId=' + this.$route.query.projectId)
      } else if (this.$route.query.page === 'password') {
        this.$router.push('/password')
      } else if (this.$route.query.page === 'market') {
        this.$router.push('/markedsplads?projectid=' + this.$route.query.projectid)
      } else if (this.$route.query.page === 'signup') {
        this.$router.push('/signup')
      } else if (this.$route.query.page === 'minekunder') {
        this.$router.push('/alle-moeder?projectID=' + this.$route.query.projectID + '&contactID=' + this.$route.query.contactID)
      } else if (this.$route.query.page === 'projectdashboard') {
        this.$router.push('/customer-projects/project-dashboard?fromLogin=1&projectId=' + this.$route.query.projectID + '&contracttype=Fagentreprise')
      } else if (this.$route.query.page === 'jule') {
        this.$router.push('/jule')
      } else if (this.$route.query.page === 'ekstraphone') {
        this.$router.push('/ekstraphone')
      } else if (this.$route.query.page === 'anbefalinger') {
        this.$router.push('/anbefalinger')
      } else if (this.$route.query.page === 'leverandoer') {
        this.$router.push('/leverandoerservice')
      } else if (this.$route.query.page === 'boostenanbefaling') {
        if (this.$route.query.cid !== undefined) {
          this.$router.push('/boost-en-anbefaling?reviewId=' + this.$route.query.reviewId)
        } else {
          this.$router.push('/boost-en-anbefaling')
        }
      } else if (this.$route.query.page === 'inbox') {
        if (this.$route.query.cid !== undefined) {
          this.$router.push('/inbox?cid=' + this.$route.query.cid)
        } else {
          this.$router.push('/inbox')
        }
      } else {
        if (res.onlycredit === 1) {
          this.$router.push('/rediger-kreditkort-oplysninger')
        } else {
          this.$router.push('/newsfeed')
        }
      }
    },
    getInitialPackageValue () {
      this.defaultpackage[0] = 'ClimatePartner'
      this.defaultpackage[1] = 'FBPostRecommendation'
      this.defaultpackage[2] = 'PartnerAccountingInteg'
      this.defaultpackage[3] = 'ExtraReservation'
      this.defaultpackage[4] = 'ExternalProWebsite'
      this.defaultpackage[5] = 'OfferCreator'
      this.defaultpackage[6] = 'PartnerloginMesterMesterReserve'
      this.defaultpackage[7] = 'PartnerLoginUdbudJobs'
      this.defaultpackage[8] = 'PartnerLoginMarketplaceReserve'
      this.defaultpackage[9] = 'PartnerloginMesterMesterPost'
      this.defaultpackage[10] = 'PartnerLoginMarketplaceViewer'
      this.defaultpackage[11] = 'PersonalPartnerLogin'
      this.defaultpackage[12] = 'AccessVideoProProfile'
      this.defaultpackage[13] = 'AccessDescriptionText'
      this.defaultpackage.forEach(elementfeature => {
        localStorage.setItem(elementfeature, false)
      })
    },
    getpackage (id, token, res, partnerpackage = []) {
      var mainpackage = partnerpackage
      var boughtfeature = []
      var packagedataaddon = mainpackage.PACKAGE_ADDONS
      var packagedatafeature = mainpackage.PACKAGE_FEATURES
      var packagedatafeatureeach = mainpackage.ACTIVE

      if (packagedatafeatureeach && packagedatafeature) {
        packagedatafeature.forEach(element => {
          boughtfeature.push(element.SHORT_CODE + '-' + element.LIMITATION)
          if (element.SHORT_CODE === 'partnerV2') {
            localStorage.setItem('showAddendum', true)
            localStorage.setItem('showAddendum', true)
          }
        })
        packagedataaddon.forEach(element2 => {
          boughtfeature.push(element2.SHORT_CODE + '-' + element2.LIMITATION)
        })
        boughtfeature.forEach((elements) => {
          var elementsname = elements.split('-')[0]
          var elementslimitations = elements.split('-')[1]
          if (this.defaultpackage.includes(elementsname)) {
            if (elementslimitations !== null && elementslimitations !== 'null') {
              localStorage.setItem(elementsname, true)
              localStorage.setItem(elementsname + 'limit', elementslimitations)
            } else {
              localStorage.setItem(elementsname, true)
            }
            if (localStorage.getItem('PartnerLoginMarketplaceReserve') || localStorage.getItem('PartnerloginMesterMesterReserve')) {
              localStorage.setItem('PartnerLoginMarketplaceViewer', true)
            }
            localStorage.setItem('PartnerloginMesterMesterReserve-nummode', res.data.nummode)
            localStorage.setItem('PartnerloginMesterMesterReserve-size', res.data.reserve_size)
            localStorage.setItem('PartnerLoginMarketplaceReserve-nummode', res.data.nummode)
            localStorage.setItem('PartnerLoginMarketplaceReserve-size', res.data.reserve_size)
            localStorage.setItem('PartnerPackageHandle', res.data.PACKAGE_HANDLE)
          }
        })
      }
      this.displayProjects(token)
      this.gotoroute(res)
    },
    displayProjects (token) {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + token
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/projectInvitations', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            if (res.data.length && res.data.length > 0) {
              localStorage.setItem('is_jobInvited', true)
            } else {
              localStorage.setItem('is_jobInvited', false)
            }
          } else {
            localStorage.setItem('is_jobInvited', false)
          }
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
          localStorage.setItem('is_jobInvited', false)
        })
    }
  }
}
</script>
<style>
#noneligeble___BV_modal_header_ {
  display: none!important;
}
#loginform .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#loginform .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#loginform .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#loginform .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#loginform .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// ProjectLogin.vue?5f188aae